<template>
    <div class="container is-fluid">
      <chart-menu/>
    </div>
</template>

<script>
import ChartMenu from '../../components/Chart/Menu.vue';

export default {
  name: 'ChartMenuList',
  components: {
    ChartMenu,
  },
};
</script>
